<template>
  <div
    v-if="renderSeoText"
    :id="id"
    class="adivare-text"
  >
    <div class="container">
      <div class="row">
        <div
          class="col-12 col-md-12"
          v-html="renderSeoText"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import AutoCollapseText from '/assets/common/js/components/autoCollapseText';

export default {
  name: "adivare-text-seo",
  props: {
    id: {
      type: String,
      required: true,
    },
    autoCollapse: {
      type: Boolean,
      default: false,
      required: false,
    },
    fontAwesomeVersion: {
      type: Number,
      default: 5,
      required: false,
    },
    autoCollapseBreakPointDown: {
      type: String,
      default: undefined,
      required: false,
    },
    seoText: {
      type: String,
      default: '',
      required: false,
    },
  },
  watch: {
    '$store.state.seo.text': {
      deep: true,
      immediate: false,
      handler() {
        this.$nextTick(() => {
          if (true === this.autoCollapse && true === this.isElement(this.$el)) this.executeAutoCollapse();
        });
      },
    },
  },
  computed: {
    renderSeoText() {
      return this.$store.state.seo.text ?? this.seoText;
    },
  },
  methods: {
    executeAutoCollapse() {
      new AutoCollapseText({
        container: this.$el,
        breakpointDown: this.autoCollapseBreakPointDown,
        fontAwesomeVersion: this.fontAwesomeVersion,
      });
    },
    isElement(element) {
      return element instanceof Element || element instanceof HTMLElement;
    }
  },
  mounted() {
    if ('function' !== typeof $().collapse) require('bootstrap/js/dist/collapse');
  }
}
</script>
